import { createUploadLink } from 'apollo-upload-client';
import type { ApolloLink } from '@apollo/client';

export default ({ uri }: { uri: string }) =>
    createUploadLink({ uri, credentials: 'include' }) as unknown as ApolloLink;
